export default __webpack_public_path__ + "static/media/Comp 2_00020.f867d152.png";